<div class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th>
                        {{ 'invest.datatables.year.shortLabel' | translate }}
                        <app-tooltip [text]="'invest.datatables.year.summary' | translate"></app-tooltip>
                    </th>
                    <th>
                        {{ 'invest.datatables.amount.shortLabel' | translate }}
                        <app-tooltip [text]="'invest.datatables.amount.summary' | translate"></app-tooltip>
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of data.years">
                    <tr>
                        <td>{{ row.year }}</td>
                        <td>
                            <span *ngIf="row.value != null">{{ row.value | formatAmount }}</span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
            <tfoot>
                <tr *ngIf="data.total.length">
                    <td colspan="2">{{ 'invest.datatables.total.shortLabel' | translate }}</td>
                </tr>
            </tfoot>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let label of data.valuesLabels">{{ label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of data.years">
                    <td *ngIf="!row.valuesByYear.length" [attr.colspan]="data.valuesLabels.length"></td>
                    <td *ngFor="let value of row.valuesByYear">
                        {{ value | formatAmount }}
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr *ngIf="data.total.length">
                    <td *ngFor="let value of data.total">{{ value | formatAmount }}</td>
                </tr>
            </tfoot>
        </table>
    </section>
</div>
